import Raven from 'raven-js';

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState)
  } catch (err) {
	Raven.captureException(err);
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
	Raven.captureException(err);
    console.log('LocalStorage save state failed: ', err);
  }
};



// WEBPACK FOOTER //
// ./src/store/localStorage.js